import { z } from "zod";

export const lineItemSchema = z.object({
  accountId: z.string().min(1).max(50).nullable(),
  amount: z.number().nullable(),
});

export const lineItemValidationSchema = z.object({
  accountId: z.string().min(1).max(50),
  amount: z.number(),
});

export const lineItemsValidationSchema = z
  .array(lineItemSchema)
  .superRefine((val, ctx) => {
    if (val.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Sachkonto darf nicht leer sein",
        path: ["accountIds"],
      });
    }

    const missingAccountId = val.some((item) => !item.accountId);

    if (missingAccountId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Sachkonto darf nicht leer sein",
        path: ["accountIds"],
      });
    }
  });

export const lineItemTableValidationSchema = z.object({
  lineItems: lineItemsValidationSchema,
  totalAmount: z.number(),
});
